import React, { useEffect, useState } from 'react';
import { getLoadingPreviewPaths } from '../model/yogaModel';

const PREVIEW_DELAY = 160;
const LOOP_PAUSE = 800;

const LOADING_PREVIEWS = getLoadingPreviewPaths()
  .map((src) => ({
    src,
    rotation: Math.random() * 12 - 6,
  }));

function LoadingView() {
  const [mobileLoop, setMobileLoop] = useState(0);

  // Restart the mobile image stack if the app is still loading after the final preview appears.
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    let timer;

    const startMobileLoop = () => {
      window.clearInterval(timer);

      if (!mediaQuery.matches) return;

      const loopDuration = (LOADING_PREVIEWS.length - 1) * PREVIEW_DELAY + LOOP_PAUSE;
      timer = window.setInterval(() => {
        setMobileLoop((loop) => loop + 1);
      }, loopDuration);
    };

    startMobileLoop();
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', startMobileLoop);
    } else {
      mediaQuery.addListener(startMobileLoop);
    }

    return () => {
      window.clearInterval(timer);
      if (typeof mediaQuery.removeEventListener === 'function') {
        mediaQuery.removeEventListener('change', startMobileLoop);
      } else {
        mediaQuery.removeListener(startMobileLoop);
      }
    };
  }, []);

  return (
    <main
      className="loading-view"
      aria-busy="true"
      aria-label="Loading practice"
    >
      <div className="loading-pose-stack" aria-hidden="true">
        {LOADING_PREVIEWS.map(({ src, rotation }, index) => {
          const stackPosition = index - Math.floor(LOADING_PREVIEWS.length / 2);

          return (
            <img
              key={`${src}-${mobileLoop}`}
              className="loading-pose-preview"
              src={src}
              alt=""
              fetchPriority="high"
              style={{
                '--stack-y': `${Math.abs(stackPosition) * 3}px`,
                '--stack-rotation': `${rotation.toFixed(2)}deg`,
                '--preview-delay': `${index * PREVIEW_DELAY}ms`,
                '--mobile-preview-delay': `${index * 0.5}s`,
                zIndex: index + 1,
              }}
            />
          );
        })}
      </div>
      <div className="loading-line-loader" aria-hidden="true" />
    </main>
  );
}

export default LoadingView;
